import { Component, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { Router } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { LanguageSelectorComponent } from "@shared/base/components/navigation/language-selector/language-selector.component";

@Component({
    selector: "app-not-authorized-app-access",
    imports: [
        MatButton,
        MatIcon,
        TranslatePipe,
        LanguageSelectorComponent,
    ],
    templateUrl: "./not-authorized-app-access.component.html",
    styleUrl: "./not-authorized-app-access.component.scss",
})
export default class NotAuthorizedAppAccessComponent {
    private readonly router = inject(Router);

    goBack() {
        this.router.navigateByUrl("/", { replaceUrl: true });
    }
}
